import { BaseModel } from "../base.model";

export class AuditAction extends BaseModel {
  id: number;
  name: string;
  description: string;
}
